import { IDefineCommand, IQuery } from 'core-ts-types';
import { OpenableElement } from '../builders/openable_element_builder';
import { IDatasource } from 'utility-ts-orm';

angular
  .module('capability-ng-priority-feed')
  .service(
    'closeOpenableElementCommand',
    (defineCommandORM: IDefineCommand, ngOpenableElementsDatastore: IDatasource<OpenableElement>) => {
      return defineCommandORM('closeOpenableElementCommand', (deferred: ng.IDeferred<IQuery[]>, element: string) => {
        ngOpenableElementsDatastore.write({ element: { id: element, isOpen: false } });
        deferred.resolve();
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-priority-feed/src/commands/close_openable_element_command.ts